/* eslint-disable global-require */
import angular from 'angular';

import AvailabilityFormController from './availability-form.controller';

export default angular.module('autoboard.formAvailability', [])
  .directive('formAvailability', () => {
    'ngInject';

    return {
      controller: AvailabilityFormController,
      controllerAs: '$ctrl',
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '<',
        customerId: '<?',
      },
      templateUrl: require('./availability-form.template.html'),
    };
  })
  .name;
